import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import BackToTopButton from './components/BackToTopButton';

function Footer() {
  return (
    <footer className="p-4 text-gray-600 dark:text-gray-200 mt-4 h-18 w-full header-footer border-t">
      <p>© Otso Rajala, 2022 | GDPR DISCLAIMER: This site is using browser local storage to store your theme preference.</p>
    </footer>
  );
}


export default function App() {
  return (
    <div className="bg-neutral-50 dark:bg-neutral-800 dark:text-gray-200">
      <Header />
      <Outlet />
      <BackToTopButton />
      <Footer />
    </div>
  );
}
